<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        <!--SLIDE-1-->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 2: Principios del desarrollo según Piaget / pág. 1">
            <div class="container-fluid">
                <div class="row" id="slide-2">
                    <div class="col-lg-6 col-md-12 col-sm-12 pr-0 p-2 pr-lg-5">
                        <div class="mt-3 mt-lg-5 p-3 pl-lg-5 mt-5  mb-0">
                            <h2 class="mt-4">2. Principios del desarrollo según Piaget</h2>
                            <p class="mt-3">En este torbellino de sensaciones indiferenciadas, se da el encuentro con otros sujetos, enlazados a una historia familiar y social que los sostiene y que influye el proceso de desarrollo; de esta manera se empieza la gran tarea de construirse como sujetos. En este proceso de construcción y a través del sistema sensorio-perceptivo, los seres humanos se van identificando con los otros, inscribiéndose a la cultura gracias al lenguaje. Los principios del desarrollo según Piaget suelen describirse de la siguiente forma:</p>
                            <h6 class="text-center my-4">Haga clic en los botones para conocer los principios del desarrollo según Piaget.</h6>
                            <div class="row align-items-center">
                                <div class="col-lg-5 col-md-12">
                                    <div class="d-flex justify-content-center">
                                        <div>
                                            <b-img src="recursos/img/DCSS0_012_Tema2_img1.png" class="d-flex mx-auto" fluid alt=""></b-img>
                                            <p class="text-center txtfiguras mt-3">Adaptada de Pikisuperstar (s. f.). </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7 col-md-12 mt-lg-0 mt-4">
                                    <button type="button" id="btn1T1S2" class="btn mt-md-3 mt-4 d-flex mx-auto cambiaestadobtn btn-activar-vista btn_activo" @click="mostrarContenido('a', $event)">a. Organización y adaptación </button>
                                    <button type="button" id="btn2T1S2" class="btn mt-md-3 mt-4 d-flex mx-auto cambiaestadobtn btn-activar-vista" @click="mostrarContenido('b', $event)">b. Asimilación y acomodación </button>
                                    <button type="button" id="btn3T1S2" class="btn mt-md-3 mt-4 d-flex mx-auto cambiaestadobtn btn-activar-vista" @click="mostrarContenido('c', $event)">c. Mecanismos del desarrollo </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 Fondo-Tema1s1 d-flex justify-lg-content-center align-items-lg-center">
                        <p class="text-right text-white url mt-2 d-none d-lg-block d-md-none RefimgActiv">Foto por Cookie_studio en <a href="https://www.freepik.es/foto-gratis/mujer-rubia-divertida-positiva-ropa-casual-muestra-signo-ok_9116730.htm#page=3&query=sign+language&position=22 " class="text-white" target="_blank" rel="noopener noreferrer">Freepik</a> </p>
                        <div class="row">
                            <div class="col-xl-10 col-lg-12 col-md-12 col-12 offset-xl-1">
                                <div class="bg-white p-4 sombracarrusel animated fadeInUp contenidoss3" id="Contenido_a">
                                    <h4 class="font-weight-bold color1Ppal">a. Organización y adaptación</h4>
                                    <p class="mt-4">Son principios básicos o funciones invariantes que, según Piaget, comparten los organismos humanos. Como lo afirma Darrigrande (2010), para Piaget “la mente humana, también opera en términos de estas dos funciones no cambiantes. Sus procesos psicológicos están organizados en sistemas coherentes y estos sistemas están preparados para adaptarse a los estímulos cambiantes del entorno” (p. 246).</p>
                                </div>
                                <div class="bg-white p-4 sombracarrusel animated fadeInUp contenidoss3 d-none" id="Contenido_b">
                                    <h4 class="font-weight-bold color1Ppal">b. Asimilación y acomodación</h4>
                                    <p class="mt-4">Consisten en acoplar la nueva información recibida para adaptarla a los esquemas existentes. Por un lado, la asimilación es la forma como un organismo responde a un estímulo que llega nuevo del contexto; por el otro, la acomodación reorganiza y modifica la estructura anterior para acomodarla a este nuevo sistema.</p>
                                </div>
                                <div class="bg-white p-4 sombracarrusel animated fadeInUp contenidoss3 d-none" id="Contenido_c">
                                    <h4 class="font-weight-bold color1Ppal">c. Mecanismos del desarrollo</h4>
                                    <p class="mt-4">De acuerdo con Meece (2000), Piaget define los siguientes cuatro factores que intervienen en el desarrollo cognoscitivo: “Maduración de las estructuras físicas heredadas / Experiencias físicas con el ambiente / Transmisión social de la información y de conocimientos / Equilibrio” (p. 104).</p>
                                </div>
                                <!-- <p class="text-right text-dark mt-2 d-none d-lg-block d-md-none">Imagen de Cookie_studio en freepik.es</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--SLIDE-1-->
    </div>
</div>
</template>

<script>
import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Tema2',
    mounted() {
        SwiperController(),
            document.title = this.$route.meta.title
    },
    methods: {
        mostrarContenido: function (numComponente, event) {
            let botones = document.querySelectorAll(".cambiaestadobtn");
            botones.forEach(elementBoton => {
                elementBoton.classList.remove("btn_activo");
            });
            event.target.classList.add("btn_activo");

            let contenidos = document.querySelectorAll(".contenidoss3");
            contenidos.forEach(element => {
                element.classList.add("d-none");
            });
            let elemento = document.querySelector("#Contenido_" + numComponente);
            elemento.classList.remove("d-none");
        }
    }
};
</script>
